import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarProfileAdmin from "../../components/TopBarProfileAdmin";
import EditProfileAdmin from "../../components/EditProfileAdmin";

function HalamanEditProfileAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarProfileAdmin />

        {/* Konten utama */}
        <div className="profile-page">
          <EditProfileAdmin />
        </div>
      </div>
    </div>
  );
}

export default HalamanEditProfileAdmin;